'use strict';

angular.module('app')
    .controller('CouponCtrl', function ($rootScope, typeURL, Coupons) {
        var vm = this;

        vm.current = typeURL;
        vm.changeCoupon = changeCoupon;
        vm.saveCoupon = saveCoupon;


        init();


        function init() {
            vm.loader = true;

            Coupons.get().then(function (data) {
                vm.coupon = data;
                vm.editCoupon = null;
            }).finally(function () {
                vm.loader = false;
            });
        }

        function saveCoupon(form) {
            form.$setSubmitted();
            if (form.$valid) {
                vm.loader = true;
                
                if (vm.editCoupon) {
                    Coupons.del(vm.editCoupon.id).then(add);
                } else {
                    add();
                }
            }

            function add() {
                return Coupons.set({couponCode: vm.couponCode}).finally(function () {
                    return init();
                }).catch(function (error) {
                    if (error.data) {
                        var err = _.map(error.data);

                        $rootScope.showNotify(err[0], 5000);
                    }
                });
            }
        }

        function changeCoupon(coupon) {
            vm.editCoupon = coupon;
        }
    });